// ======================================================================
// File Name       : userHistoryLivePerformance
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import * as actionTypes from '../constants/ActionTypes';
import { HYPHEN, RETURN_MAX_NUM } from '../constants/index';
import * as userUtils from '../utils/UserUtils';

const initialState = {
  initialData: {
    contentSortType: null,
    ascendingDescendingSort: null,
    startPosition: 0,
    userSecernId: '',
    liveStartFrom: null,
    liveStartTo: null,
    returnMaxNum: RETURN_MAX_NUM,
    userAttributeKeyNum: 1,
    userAttributeSearchText: '',
    liveName: '',
    organizerUserName: '',
  },
  liveStatusList: [],
  recordNum: 0,
  recordNumRelation: 0,
  liveList: [],
  livePerformanceObj: {},
  liveUserAttributeObj: {},
  userAttributeList: [],
};

export default function userHistoryLivePerformance(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LIVE_PERFORMANCE_LIST:
      { const { livePerformanceList, recordNum } = action;
        const livePerformanceObj = livePerformanceList;
        let liveList = [];
        if (livePerformanceObj && Object.prototype.hasOwnProperty.call(livePerformanceObj, 'bySecernId')) {
          liveList = livePerformanceObj.bySecernId;
        }
        return { ...state, liveList, livePerformanceObj, recordNum };
      }

    case actionTypes.LIVE_PERFORMANCE_LIST_USER_COUNT:
      {
        const { liveListUserCount } = action;
        return { ...state };
      }
    // #7119 START
    case actionTypes.LIVE_PERFORMANCE_DETAIL:
      {
        const { liveList, liveReserveDetail, userAttributeList, recordNumRelation } = action;
        if (liveList && liveList.allSecernIds && liveList.bySecernId && liveList.allSecernIds.length) {
          liveList.allSecernIds.reduce((acc, cur) => {
            if (cur && liveList.bySecernId[cur]) {
              const liveEnteringLeavingDateListTemp = liveList.bySecernId[cur].liveEnteringLeavingDateList;
              const liveStartFrom = moment(liveReserveDetail.liveStartFrom);
              const liveStartTo = moment(liveReserveDetail.liveStartTo);
              liveList.bySecernId[cur].userName = liveList.bySecernId[cur].participantUserName;
              liveList.bySecernId[cur].loginId = liveList.bySecernId[cur].participantLoginId;
              if (liveEnteringLeavingDateListTemp) {
                const arrayPercent = userUtils.createArrayDurationForChart(liveStartFrom, liveStartTo, liveEnteringLeavingDateListTemp);
                liveList.bySecernId[cur].arrayDataSetsForChart = arrayPercent;
              }
            }
            return acc;
          }, []);
        }
        return { ...state, liveList, liveReserveDetail, userAttributeList, recordNumRelation };
      }
    case actionTypes.LIVE_PERFORMANCE_DETAIL_PAGING: {
      const { liveList } = action;
      const { liveReserveDetail } = state;
      if (liveList && liveList.allSecernIds && liveList.bySecernId && liveList.allSecernIds.length) {
        liveList.allSecernIds.reduce((acc, cur) => {
          if (cur && liveList.bySecernId[cur]) {
            const liveEnteringLeavingDateListTemp = liveList.bySecernId[cur].liveEnteringLeavingDateList;
            const liveStartFrom = moment(liveReserveDetail.liveStartFrom);
            const liveStartTo = moment(liveReserveDetail.liveStartTo);
            liveList.bySecernId[cur].userName = liveList.bySecernId[cur].participantUserName;
            liveList.bySecernId[cur].loginId = liveList.bySecernId[cur].participantLoginId;
            if (liveEnteringLeavingDateListTemp) {
              const arrayPercent = userUtils.createArrayDurationForChart(liveStartFrom, liveStartTo, liveEnteringLeavingDateListTemp);
              liveList.bySecernId[cur].arrayDataSetsForChart = arrayPercent;
            }
          }
          return acc;
        }, []);
      }
      return { ...state, liveList };
    }
    // #7119 END
    // #7129 START
    case actionTypes.RESET_LIVE_PERFORMANCE_DETAIL: {
      return {
        ...state,
        liveReserveDetail: {},
      };
    }
    // #7129 END
    default:
      return state;
  }
}
